import { http } from '../utils/axios';
import {
  TAuthData,
  TResponseAuth,
  TForgotPasswordData,
  TResetPasswordData,
  IResponseOTP,
  TResponseOTP
} from '../types';
import {
  getOTPTokenFromLocalStorage,
  removeOTPTokenFromLocalStorage,
  setOTPTokenToLocalStorage,
  setTokenToLocalStorage
} from '../utils/local-storage';
import { TwoFATypes } from 'shared/enums';

class AuthService {
  private static instance: AuthService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }

    return AuthService.instance;
  }

  login = async (payload: TAuthData) => {
    const disabled2FA = `${process.env.REACT_APP_ENABLE_2FA}` === 'false';
    const url = disabled2FA ? '/auth/client' : '/auth/login';

    // Extract reCAPTCHA token and credentials
    const { username, password, recaptcha_token } = payload;

    const { data } = await http<TResponseAuth>({
      url,
      method: 'POST',
      auth: { username, password },
      data: { recaptcha_token },
      params: {
        app: 'affiliate-admin'
      }
    });
    if (disabled2FA) {
      setTokenToLocalStorage(data.token);
    } else {
      setOTPTokenToLocalStorage(data.OTPToken);
    }
    return data;
  };

  forgotPassword = async (payload: TForgotPasswordData) => {
    await http({
      url: '/auth/forgot',
      method: 'POST',
      data: payload,
      params: {
        access_token: process.env.REACT_APP_MASTER_KEY
      }
    });
  };

  resetPassword = async (payload: TResetPasswordData) => {
    const { data } = await http<TResponseAuth>({
      url: '/auth/reset',
      method: 'POST',
      data: payload,
      params: {
        access_token: payload.access_token
      }
    });

    setTokenToLocalStorage(data.token);
  };

  getMe = async () => {
    const { data } = await http<any>({
      url: '/users/me',
      method: 'GET'
    });

    console.log('data', data);
  };

  changeType2fa = async (type: TwoFATypes) => {
    await http<IResponseOTP>({
      url: '/two-factor/actions/change-type',
      method: 'PATCH',
      params: { access_token: getOTPTokenFromLocalStorage(), type }
    });
  };

  getOtpCode = async () => {
    await http<IResponseOTP>({
      url: 'auth/client/otp-code',
      method: 'GET',
      params: { access_token: getOTPTokenFromLocalStorage() }
    });
  };

  verifyOtpCode = async (code: string) => {
    const { data } = await http<TResponseOTP>({
      url: '/auth/client/otp-code',
      method: 'POST',
      params: { access_token: getOTPTokenFromLocalStorage(), code }
    });

    setTokenToLocalStorage(data.token);
    removeOTPTokenFromLocalStorage();
    return data.user;
  };
}

const instance = AuthService.getInstance();

export default instance;
